import { env } from "process";
import { ReactElement } from "react";
import FlexDisplayItem from "src/components/atoms/FlexDisplayItem";
import LeadForm from "src/components/forms/LeadForm";
import ReferralForm from "src/components/forms/ReferralForm";

const getForm = (formType: string, data: any): ReactElement => {
  switch (formType) {
    case "Referral Form":
      return <ReferralForm {...data} />;
    default:
      return <LeadForm {...data} />;
  }
};

const form = (data: any): ReactElement => {
  const { formType, formHorizontalAlignment, formVerticalAlignment } = data;
  
  const form = process.env.DEACTIVATE_ALL_FORMS ? (<></>) : (
    <FlexDisplayItem
      fv={formVerticalAlignment}
      fh={formHorizontalAlignment}
      themeName="Form Card"
    >
      {getForm(formType, data)}
    </FlexDisplayItem>
  );

  return form;
};

export default form;
